import React, { useEffect, useState } from "react";
import { Dialog, DialogActions, DialogContent, DialogTitle, Button, IconButton, Checkbox, FormControlLabel, FormControl, Container, Box, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import DeleteIcon from "@mui/icons-material/Delete"; // สำหรับไอคอนลบ
import apiClient from "../api/apiClient";

const UploadConfig = () => {
  const [configs, setConfigs] = useState([{ usesuffix: false, useprefix: false, usekeyword: false, active: "N" }]);
  const [newScreen, setNewScreen] = useState("");
  const [deleteId, setDeleteId] = useState(null);

  useEffect(() => {
    apiClient.get("/api/config-upload")
      .then((res) => {
        setConfigs(res.data);
      })
      .catch(error => {
        openDialogWithMessage(error.response?.data?.error || "Failed to load data.", "Load Failed", "#e40000", "Close", "white", "#ff1616", "#d40000");
      });
  }, []);

  const handleChange = (index, field, value) => {
    const newConfigs = [...configs];
    newConfigs[index][field] = value;
    setConfigs(newConfigs);
  };

  const handleSave = async () => {
    const token = localStorage.getItem("token");

    try {
      const response = await apiClient.post("/api/config-upload-update", { configs }, {
        headers: { Authorization: `Bearer ${token}` }
      });
      openDialogWithMessage(response.data.message, "Config Complete", "#519a39", "OK", "white", "#66bb49", "#3f762c");
    } catch (error) {
      openDialogWithMessage(error.response?.data?.error || "Failed to update data.", "Config Failed", "#e40000", "Close", "white", "#ff1616", "#d40000");
    }
  };

  const confirmDelete  = (id,screen) => {
    setDeleteId(id);  
    setDialogType("delete");
    openDialogWithMessage(`คุณแน่ใจใช่ไหมที่จะลบชื่อไฟล์ ${screen} ?`, "Confirm Delete", "#e40000", "Delete", "white", "#ff1616", "#d40000");
  };

  const handleDelete = async () => {
    handleCloseDialog();
    const token = localStorage.getItem("token");
    if (!deleteId) return; 

    try {
        const response = await apiClient.delete(`/api/config-upload-delete/${deleteId}`, {
          headers: { Authorization: `Bearer ${token}` }
        });
        // แจ้งเตือนว่าการลบสำเร็จ
        openDialogWithMessage(response.data.message, "Delete Success", "#519a39", "OK", "white", "#66bb49", "#3f762c");
        
        // รีเฟรชข้อมูลหลังจากลบ
        const updatedConfigs = configs.filter(config => config.id !== deleteId);
        setConfigs(updatedConfigs);
      } catch (error) {
        openDialogWithMessage(error.response?.data?.error || "Failed to delete.", "Delete Failed", "#e40000", "Close", "white", "#ff1616", "#d40000");
      }
  };

  const handleAddScreen = () => {
    if (!newScreen.trim()) {
      openDialogWithMessage("กรุณาใส่ไฟล์ที่ต้องการเช็ค", "Config Failed", "#e40000", "Close", "white", "#ff1616", "#d40000");
      return;
    }

    const newConfig = {
      id: null,
      screen: newScreen,
      useprefix: false,
      prefix: "",
      usekeyword: false,
      keyword: "",
      usesuffix: false,
      suffix: "",
    };

    setConfigs([...configs, newConfig]);
    setNewScreen("");
  };

  const [openDialog, setOpenDialog] = useState(false);
  const [dialogType, setDialogType] = useState("ok");
  const [dialogMessage, setDialogMessage] = useState("");
  const [dialogTitle, setDialogTitle] = useState("Information");
  const [dialogTitleColor, setDialogTitleColor] = useState("black");
  const [dialogButtonText, setDialogButtonText] = useState("Close");
  const [dialogButtonTextColor, setDialogButtonTextColor] = useState("black");
  const [dialogButtonColor, setDialogButtonColor] = useState("white");
  const [dialogButtonColorh, setDialogButtonColorh] = useState("white");

  const openDialogWithMessage = (message, title = "Information", titleColor = "black", buttonText = "Close", buttonTextColor = "black", buttonColor = "white", buttonColorh = "white") => {
    setDialogMessage(message);
    setDialogTitle(title);
    setDialogTitleColor(titleColor);
    setDialogButtonText(buttonText);
    setDialogButtonTextColor(buttonTextColor);
    setDialogButtonColor(buttonColor);
    setDialogButtonColorh(buttonColorh);
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
    setDialogType("ok");
    setDeleteId(null);
  };

  return (
    <Container component="main" maxWidth="96%">
      <Box sx={{
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      marginTop: "14px",
      padding: 3,
      borderRadius: 2, // มุมมน
      boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)", // เงาบางๆ
      backgroundColor: "background.paper",
      border: "1px solid #e0e0e0", // เส้นขอบบางๆ สีเทาอ่อนมาก
    }}>
        <Box
            sx={{
                fontSize: "calc(14px + 0.5vw)", // ขนาดตัวหนังสือเท่ากับ Typography variant="h5"
                fontWeight: "bold", // ตัวหนา
                marginTop: "-12px",
                paddingTop: "0px",
                paddingBottom: "6px", // เว้นระยะจากข้อความลงมา
                lineHeight: "1.2",
                borderBottom: "1px solid #e0e0e0", // เส้นขอบเฉพาะด้านล่าง สีเทาอ่อน
                color: "#333", // สีตัวหนังสือเทาเข้ม
                width: "100%", // ให้เส้นขอบยืดเต็มความกว้าง
                textAlign: "center", // จัดข้อความชิดซ้าย
                verticalAlign: "middle",
                boxShadow: "none",
                borderRadius: 0,
            }}
            >
            ตั้งค่าการเช็คชื่อไฟล์ในการอัพโหลดข้อมูล
        </Box>

        <Box sx={{ display: "flex", marginBottom: 2, boxShadow: "none" }}>
          <input
            type="text"
            value={newScreen}
            onChange={(e) => setNewScreen(e.target.value)}
            placeholder="ชื่อไฟล์ใหม่ที่ต้องการเช็ค"
            style={{ padding: "10px", width: "250px", marginRight: "10px" }}
          />
          <Button variant="contained" onClick={handleAddScreen}>เพิ่มชื่อไฟล์</Button>
        </Box>

        <Box sx={{ overflowX: "auto", boxShadow: "none" }}>
           <table border="0" style={{ width: "100%", borderCollapse: "collapse" }}>
           <thead style={{
                backgroundColor: "#f5f5f5", // พื้นหลังเทาอ่อนมากๆ
                color: "rgb(63, 60, 60)", // ตัวหนังสือเทาเข้มมาก
                fontWeight: "bold", // ตัวหนา
                fontSize: "calc(14px - 0.2vw)",
                borderBottom: "2px solid #333333",
            }}>
              <tr>
                <th>ชื่อไฟล์</th>
                <th>ใช้ Prefix</th>
                <th>Prefix</th>
                <th>ใช้ Keyword</th>
                <th>Keyword</th>
                <th>ใช้ Suffix</th>
                <th>Suffix</th>
                <th>Active</th>
                <th>ลบ</th>
              </tr>
            </thead>
            <tbody>
              {configs.map((config, index) => (
                <tr key={index}>
                  <td style={{
                    padding: "8px",
                    textAlign: "left",
                    verticalAlign: "middle",
                    borderBottom: "1px solid #e0e0e0",
                    fontSize: "calc(14px - 0.2vw)",
                    }}>
                    {config.screen}
                  </td>
                  <td style={{ padding: 0, textAlign: "center", verticalAlign: "middle",borderBottom: "1px solid #e0e0e0", }}>
                    <Checkbox
                      checked={Boolean(config.useprefix)}
                      onChange={(e) =>
                        handleChange(index, "useprefix", e.target.checked ? true : false)
                      }
                    />
                  </td>
                  <td style={{ padding: 0, textAlign: "center", verticalAlign: "middle",borderBottom: "1px solid #e0e0e0", }}>
                    <input
                      type="text"
                      value={config.prefix || ""}
                      onChange={(e) => handleChange(index, "prefix", e.target.value)}
                      disabled={!config.useprefix}
                      style={{
                        width: "100%",
                        boxSizing: "border-box", 
                        padding: "8px",
                      }}
                    />
                  </td>
                  <td style={{ padding: 0, textAlign: "center", verticalAlign: "middle",borderBottom: "1px solid #e0e0e0", }}>
                    <Checkbox
                      checked={!!config.usekeyword}
                      onChange={(e) =>
                        handleChange(index, "usekeyword", e.target.checked ? true : false)
                      }
                    />
                  </td>
                  <td style={{ padding: 0, textAlign: "center", verticalAlign: "middle",borderBottom: "1px solid #e0e0e0", }}>
                    <input
                      type="text"
                      value={config.keyword || ""}
                      onChange={(e) => handleChange(index, "keyword", e.target.value)}
                      disabled={!config.usekeyword}
                      style={{
                        width: "100%",
                        boxSizing: "border-box", 
                        padding: "8px",
                      }}
                    />
                  </td>
                  <td style={{ padding: 0, textAlign: "center", verticalAlign: "middle",borderBottom: "1px solid #e0e0e0", }}>
                    <Checkbox
                      checked={!!config.usesuffix}
                      onChange={(e) =>
                        handleChange(index, "usesuffix", e.target.checked ? true : false)
                      }
                    />
                  </td>
                  <td style={{ padding: 0, textAlign: "center", verticalAlign: "middle",borderBottom: "1px solid #e0e0e0", }}>
                    <input
                      type="text"
                      value={config.suffix || ""}
                      onChange={(e) => handleChange(index, "suffix", e.target.value)}
                      disabled={!config.usesuffix}
                      style={{
                        width: "100%",
                        boxSizing: "border-box", 
                        padding: "8px",
                      }}
                    />
                  </td>
                  <td style={{ padding: 0, textAlign: "center", verticalAlign: "middle",borderBottom: "1px solid #e0e0e0", }}>
                    <Checkbox
                      checked={config.active === "Y"}
                      onChange={(e) => handleChange(index, "active", e.target.checked ? "Y" : "N")}
                    />
                  </td>
                  <td style={{ padding: 0, textAlign: "center", verticalAlign: "middle",borderBottom: "1px solid #e0e0e0", }}>
                    <IconButton onClick={() => confirmDelete(config.id,config.screen)} color="error">
                        <DeleteIcon />
                    </IconButton>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </Box>

        <Button variant="contained" onClick={handleSave} sx={{ marginTop: 2 }}>บันทึกข้อมูล</Button>
      </Box>

      {/* Dialog for invalid files */}
      <Dialog open={openDialog} onClose={handleCloseDialog} sx={{maxWidth: "auto",  width: "auto", margin: "auto",overflow: "visible", }} disableEnforceFocus>
        <DialogTitle sx={{color: dialogTitleColor,fontSize: "1.3rem",fontWeight: "400",textAlign: "left",padding: "5px",minHeight: "30px",whiteSpace: "pre-wrap",paddingRight: "40px", }}>
        {dialogTitle} 
        </DialogTitle>
        <IconButton sx={{position: "absolute",right: "5px",top: "3px",borderRadius: "8px", }} onClick={handleCloseDialog}> 
            <CloseIcon /> 
        </IconButton>
        <DialogContent sx={{ fontSize: "1rem",maxHeight: "100%", overflowY: "auto", paddingBottom: "0",whiteSpace: "pre-wrap",wordBreak: "break-word",textAlign: "center", }}>
        {dialogMessage}
        </DialogContent>
        <DialogActions sx={{display: "flex", justifyContent: "center", alignItems: "center",marginTop: "20px",}}>
        {dialogType === "delete" ? (
           <>
            <Button
                variant="contained"
                sx={{ backgroundColor: "#989898", color: "white", "&:hover": { backgroundColor: "#878787" } }}                
                onClick={handleCloseDialog}
            >
                Cancel
            </Button>
            <Button
                variant="contained"
                sx={{ backgroundColor: dialogButtonColor, color: dialogButtonTextColor, "&:hover": { backgroundColor: dialogButtonColorh } }}
                onClick={handleDelete} 
            >
                {dialogButtonText}
            </Button>
          </>
        ) : (
            <Button variant="contained" sx={{ backgroundColor: dialogButtonColor, color: dialogButtonTextColor, "&:hover": { backgroundColor: dialogButtonColorh } }} onClick={handleCloseDialog}>
                {dialogButtonText}
            </Button>
        )}
        </DialogActions>
    </Dialog>

    </Container>
  );
};

export default UploadConfig;
